module.exports = __webpack_public_path__ + "static/media/creativity1.21225793.png";